// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeInMixin {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOutMixin {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.SelectDashboardFolderModal {
  padding: 32px;
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}
.SelectDashboardFolderModal h2 {
  color: var(--color_neutral_900);
  font-size: 24px;
  font-weight: 600;
}
.SelectDashboardFolderModal .SelectDashboardFolderModal-foldersList {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  width: 450px;
  height: 350px;
  overflow-y: scroll;
}
.SelectDashboardFolderModal .SelectDashboardFolderModal-foldersList::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
.SelectDashboardFolderModal .SelectDashboardFolderModal-foldersList::-webkit-scrollbar-track {
  background: transparent;
}
.SelectDashboardFolderModal .SelectDashboardFolderModal-foldersList::-webkit-scrollbar-thumb {
  background: var(--color_neutral_200);
  height: 80px;
  border-radius: 50px;
}
.SelectDashboardFolderModal .SelectDashboardFolderModal-foldersList:hover::-webkit-scrollbar-thumb {
  background: var(--color_neutral_400);
}
.SelectDashboardFolderModal .SelectDashboardFolderModal-foldersList::-webkit-scrollbar-thumb:active {
  background: var(--color_neutral_500);
}
.SelectDashboardFolderModal .SelectDashboardFolderModal-foldersList:after {
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0) 16.67%, #fff);
  content: "";
  height: 20px;
  left: 0;
  bottom: 90px;
  position: fixed;
  width: calc(100% - 7px);
}
.SelectDashboardFolderModal .SelectDashboardFolderModal-buttonsSection {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-end;
}
.SelectDashboardFolderModal .SelectDashboardFolderModal-emptyState {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 24px;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/mixins.scss","webpack://./src/modules/dashboard/select-dashboard-folder-modal/select-dashboard-folder-modal.styles.scss"],"names":[],"mappings":"AAwCA;EACE;IACE,UAAA;ECvCF;EDyCA;IACE,UAAA;ECvCF;AACF;AD0CA;EACE;IACE,UAAA;ECxCF;ED0CA;IACE,UAAA;ECxCF;AACF;AAbA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AAeF;AAbE;EACE,+BAAA;EACA,eAAA;EACA,gBAAA;AAeJ;AAZE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AAcJ;ADpBE;EACE,UAAA;EACA,WAAA;ACsBJ;ADnBE;EACE,uBAAA;ACqBJ;ADlBE;EACE,oCAdM;EAeN,YAAA;EACA,mBAAA;ACoBJ;ADhBI;EACE,oCApBS;ACsCf;ADdE;EACE,oCAxBY;ACwChB;AA5BI;EACE,sEAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,YAAA;EACA,eAAA;EACA,uBAAA;AA8BN;AA1BE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;AA4BJ;AAzBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;AA2BJ","sourcesContent":["@mixin line-clamp($lines, $wordBreak: break-word) {\n  display: -webkit-box;\n  line-clamp: $lines;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: $wordBreak;\n}\n\n@mixin scrollbar(\n  $color: var(--color_neutral_200),\n  $colorHover: var(--color_neutral_400),\n  $colorActive: var(--color_neutral_500)\n) {\n  &::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $color;\n    height: 80px;\n    border-radius: 50px;\n  }\n\n  &:hover {\n    &::-webkit-scrollbar-thumb {\n      background: $colorHover;\n    }\n  }\n\n  &::-webkit-scrollbar-thumb:active {\n    background: $colorActive;\n  }\n}\n\n@keyframes fadeInMixin {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOutMixin {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@mixin fadeIn($timing, $length, $delay, $fill) {\n  animation: fadeInMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin fadeOut($timing, $length, $delay, $fill) {\n  animation: fadeOutMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin noise {\n  position: relative;\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    z-index: -1;\n    background-image: url('./assets/images/png/noise.png');\n    background-position: 0% 0%;\n    background-size: 36.23046875px 36.23046875px;\n    background-repeat: repeat;\n    border-radius: 12px;\n    opacity: 0.3;\n  }\n}\n\n@mixin scoped-excluded($selector, $exclude-class) {\n  :is(#{$selector}):not(:where(#{$exclude-class} *)) {\n    @content;\n  }\n}\n","@import 'src/mixins';\n\n.SelectDashboardFolderModal {\n  padding: 32px;\n  display: flex;\n  flex-direction: column;\n  row-gap: 24px;\n\n  h2 {\n    color: var(--color_neutral_900);\n    font-size: 24px;\n    font-weight: 600;\n  }\n\n  .SelectDashboardFolderModal-foldersList {\n    display: flex;\n    flex-direction: column;\n    row-gap: 8px;\n    width: 450px;\n    height: 350px;\n    overflow-y: scroll;\n\n    @include scrollbar;\n\n    &:after {\n      background: linear-gradient(180deg, hsla(0, 0%, 100%, 0) 16.67%, #fff);\n      content: '';\n      height: 20px;\n      left: 0;\n      bottom: 90px;\n      position: fixed;\n      width: calc(100% - 7px);\n    }\n  }\n\n  .SelectDashboardFolderModal-buttonsSection {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    justify-content: flex-end;\n  }\n\n  .SelectDashboardFolderModal-emptyState {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    row-gap: 24px;\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
